export default __webpack_public_path__ + "static/media/featured_area_kitchener.774d5866.webp";